module.exports = __webpack_public_path__ + "img/service-kandash.a690034.png";